import React, { useState, useMemo } from 'react';
import { DeleteOutlined, FileTextOutlined } from '@ant-design/icons';
import { Upload, message } from 'antd';
import moment from 'moment';
import { Table, Pagination } from '..';
import columns from './column';
import Wrapper, { UploadItem } from './style';
import { pageOptions, paginationPage } from '../../configs/table';
import { analyzerSample } from '../../assets';

const { Dragger } = Upload;

const Index = (props) => {
  const { setIsDisabledImport, data = [], setData } = props;

  const [dataSource, setDataSource] = useState(data || []);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [pageSize, setPageSize] = useState(pageOptions[0]);
  const [currentPage, setCurrentPage] = useState(0);

  const onChangePage = (page) => {
    setCurrentPage(page - 1);
  };

  const onChangeUpload = (e) => {
    const reader = new FileReader();
    setIsLoading(true);
    const { fileList } = e;
    setDataSource(fileList);
    if (fileList.length > 0) {
      setIsLoadingTable(true);
      reader.readAsText(fileList[0].originFileObj);
      reader.onload = async () => {
        const splittedByLine = reader.result.split('\n');
        const splittedColumns = splittedByLine[0].replace('\r', '').split(',');

        const columnName = ['date', 'time', 'store name', 'qty', 'total sales'];

        const columnCheck =
          splittedColumns.length === columnName.length &&
          splittedColumns.every((value) => {
            return columnName.includes(value.trim().toLowerCase());
          });

        if (columnCheck) {
          const rowCheck = splittedByLine.slice(1).filter((record) => {
            const slicedRecord = record.split(',');
            const recordLength = slicedRecord.length;
            const recordCheck = slicedRecord.reduce((totalEmpty, element) => {
              if (element.trim() === '') {
                return totalEmpty === totalEmpty + 1;
              }
              return totalEmpty;
            }, 0);

            if (recordCheck !== recordLength) {
              return record;
            }
            return null;
          });
          const listOfRedemptions = rowCheck.map((item, index) => {
            const splittedItem = item.split(',');

            const date = splittedItem?.[0] || '';
            const time = splittedItem?.[1] || '';
            const storeName = splittedItem?.[2] || '';
            let qty = splittedItem?.[3] || '';
            let totalSales = splittedItem?.[4]
              ? splittedItem?.[4]?.replace(/\r/, '')
              : '';

            // mandatory:
            // - date
            // - store name
            // - total sales
            // - qty
            // checking mandatory field
            let isValid = [date, storeName, totalSales, qty].reduce(
              (result, currentItem) => {
                const tmp = currentItem !== '';
                return tmp && result;
              },
              true
            );

            totalSales = totalSales === '' ? '' : totalSales;
            qty = qty === '' ? '' : qty;

            // date validation
            const redeemdAt = moment(`${date} ${time}`);
            isValid = isValid && redeemdAt.isValid();

            // number validation
            totalSales = Number(totalSales);
            if (Number.isNaN(totalSales)) {
              isValid = false && isValid;
            }

            return {
              id: index,
              store_name: storeName,
              qty: Number(qty),
              total_sales: totalSales,
              redemeed_at: redeemdAt,
              is_valid: isValid,
            };
          });

          setData(listOfRedemptions);
          setIsLoadingTable(false);
          setIsDisabledImport(false);
        }
        if (!columnCheck) {
          message.error('Invalid CSV');
          setIsLoadingTable(false);
        }
      };
    }
    setIsLoading(false);
  };

  const onDeleteItem = () => {
    setDataSource([]);
    setData([]);
    setIsDisabledImport(true);
  };

  const beforeUpload = () => {
    return false;
  };

  const onDownloadSample = () => {
    window.open(analyzerSample);
  };

  const totalValid = useMemo(() => {
    return (
      data?.filter((item) => {
        return item.is_valid;
      }).length || 0
    );
  }, [data]);
  const totalInvalid = useMemo(() => {
    return (
      data?.filter((item) => {
        return !item.is_valid;
      }).length || 0
    );
  }, [data]);

  return (
    <Wrapper>
      <div className="container_contact_upload_csv">
        {dataSource.length === 0 && (
          <Dragger
            className="container_contact_upload_drag"
            accept=".csv"
            onChange={onChangeUpload}
            maxCount={1}
            progress
            showUploadList={false}
            beforeUpload={beforeUpload}
          >
            <div className="container_contact_upload_text">
              <p className="font-subtitle2 black1">
                Drag and drop your files anywhere or
              </p>
              <div className="black1 font-paragraph_medium container_contact_upload_btn">
                Upload File
              </div>
            </div>
          </Dragger>
        )}
        {dataSource.length > 0 && (
          <UploadItem>
            <div className="container_upload_item">
              <div className="container_upload_item_icon">
                <FileTextOutlined />
              </div>
              <div className="container_upload_item_text">
                <div className="font-paragraph">{dataSource?.[0]?.name}</div>
                <div className="font-paragraph_medium">{`${dataSource?.[0]?.size} Kb`}</div>
              </div>
            </div>
            <div
              className="container_upload_delete_icon"
              aria-hidden="true"
              onClick={onDeleteItem}
            >
              <DeleteOutlined />
            </div>
          </UploadItem>
        )}
        {!isLoading && dataSource.length === 0 && (
          <p className="font-paragraph">
            Didn’t have contact template for CSV file?
            <span
              className="container_contact_upload_download_text orange1"
              aria-hidden="true"
              onClick={onDownloadSample}
            >
              {' Download CSV Template'}
            </span>
          </p>
        )}
        {isLoading && dataSource.length > 0 && (
          <div className="container_import_modal_loading_text">
            <p className="font-paragraph_medium ">
              Please wait we want to show your data here...
            </p>
          </div>
        )}
        {!isLoading && dataSource.length > 0 && (
          <div className="font-paragraph black2 container_import_modal_total">
            Total data display
            <span>{` (${totalValid}) success`}</span>
            {' and '}
            <span>{` (${totalInvalid}) failed`}</span>
          </div>
        )}
        {!isLoading && dataSource.length > 0 && (
          <>
            <Table
              dataSource={data}
              columns={columns}
              pagination={paginationPage({ pageSize, currentPage })}
              rowKey="id"
              loading={isLoadingTable || isLoadingTable || isLoading}
              className="component_contact_table"
              rowClassName={(record) => {
                const isValid = record?.is_valid;
                if (!isValid) {
                  return 'disabled-row';
                }
                return '';
              }}
            />
            <Pagination
              total={data?.length}
              pageSize={pageSize}
              setPageSize={setPageSize}
              current={currentPage + 1}
              options={pageOptions}
              onChange={onChangePage}
            />
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default Index;
